import React from 'react';
import ProposalRichTextBubbleEditor from '../ProposalRichText/ProposalRichTextBubbleEditor';
import ProposalBoxAlign from '../ProposalBoxAlign/ProposalBoxAlign';

/**
 * Éditeur inline titre — Tiptap + mise en page bloc (margin auto, pas flex-end).
 */
export default function ProposalTitleBubbleEditor({
  id,
  html = '',
  textStyle = null,
  drawMode = false,
  alignVertical = 'center',
  blockLayoutStyle = {},
  className = '',
  style,
}) {
  const editor = (
    <div style={blockLayoutStyle}>
      <ProposalRichTextBubbleEditor
        id={id}
        html={html}
        contentProp="html"
        textStyle={textStyle}
        drawMode={drawMode}
        className={className}
        style={style}
        backgroundColor={textStyle?.backgroundColor}
      />
    </div>
  );

  if (drawMode) return editor;

  return (
    <ProposalBoxAlign horizontal="start" vertical={alignVertical} innerMode="full">
      {editor}
    </ProposalBoxAlign>
  );
}
